// extracted by mini-css-extract-plugin
export default {"item":"Chip_item__sBHMN","selected":"Chip_selected__yOggv","count":"Chip_count__ofy39"};